import { PersistGate } from "redux-persist/integration/react";
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { Provider } from "react-redux";
import { store, persistor } from "./redux/store/configStore";
import IndexPage from "./views/index";
import SignUpComplete from "./views/signup-complete";
import Dashboard from "./views/dashboard";
import ForgetPassword from "./views/forgetPassword";
import CreateRatesForm from "../src/views/Rates-Management/CreateRatesForm";
function App() {
  // main routes
  let routes = [
    {
      path: "/",
      component: IndexPage,
      exact: true,
    },
    {
      path: "/agents/info",
      component: SignUpComplete,
      exact: false,
    },
    {
      path: "/forget-password",
      component: ForgetPassword,
      exact: false,
    },
    {
      path: "/dashboard",
      component: Dashboard,
      exact: false,
    },
    {
      path: "/dashboard/Rates/create",
      component: ForgetPassword,
      exact: false
    },
  ];

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <Switch>
            {routes.map((route, i) => {
              return (
                <Route
                  key={i}
                  exact={route["exact"]}
                  path={route["path"]}
                  component={route["component"]}
                />
              );
            })}
          </Switch>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
